import styled from 'styled-components'

export const VideoContainer = styled.div`
	margin-top: 16px;
	height: 400px;
	background-color: rgba(200, 200, 200, 1);
`
